export * from './ubiLayoutDataGrid.component';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiLayoutDataGrid/index.ts